var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.onLandingPage)?_c('the-header'):_vm._e(),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1),(!_vm.onLandingPage)?_c('the-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }